import React, { useMemo } from 'react';
import { PalletStockScreenProps, ProductCarrierItemDataKeys } from './PalletStockScreen';
import styles from './PalletScreenComponent.module.scss';
import DataGrid from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { Template } from 'devextreme-react/core/template';

import { palletStockScreensGridId } from './inspectorOptions';
import { WMSProductCarriersStore } from '../../../store/models/WMSBasicStocksModel';
import WarehouseNameColumnTemplate from '../../templates/dataGrid/column/warehouse-name-column-template/WarehouseNameColumnTemplate';
import CarrierTypeAsyncColumnTemplate from '../../templates/dataGrid/column/carrier-type-async-column-template/CarrierTypeAsyncColumnTemplate';
import AllowedStacksHeaderTemplate from '../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeaderTemplate';

const PalletStockScreenComponent = (props: PalletStockScreenComponentProps) => {
    const productCarriersDataSource = useMemo(
        () => ({
            store: WMSProductCarriersStore,
            select: ProductCarrierItemDataKeys,
        }),
        []
    );

    return (
        <div className={styles.container}>
            <div className={styles.viewItems}>
                <DataGrid
                    inspectorId={palletStockScreensGridId}
                    dataSource={productCarriersDataSource}
                >
                    <Template name="WarehouseNameColumn" render={WarehouseNameColumnTemplate} />
                    <Template
                        name="CarrierTypeAsyncColumn"
                        render={CarrierTypeAsyncColumnTemplate}
                    />
                    <Template name="AllowedStacksHeader" render={AllowedStacksHeaderTemplate} />
                </DataGrid>
            </div>
        </div>
    );
};

export default PalletStockScreenComponent;

export type PalletStockScreenComponentProps = PalletStockScreenProps;
